import React, { createContext, useContext, useState, useEffect } from "react";

export const LOCATIONS = {
  kvilletorget: {
    id: "kvilletorget",
    shortName: "Barley's Kvilletorget",
    address: "Kvilletorget 20",
    city: "Göteborg",
    phonenumber: "+0317303061",
  },
  skanstorget: {
    id: "skanstorget",
    shortName: "Barley's Skanstorget",
    address: "Skanstorget 4",
    city: "Göteborg",
    phonenumber: "+0317303062",
  },
};

const LocationContext = createContext(null);

export const LocationProvider = ({ children }) => {
  const [location, setLocationState] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const savedAddress = localStorage.getItem("restaurant_address_new");
    const savedId = localStorage.getItem("barleys_location_id");

    if (savedAddress && savedId && LOCATIONS[savedId]) {
      // restaurant_address is present — restore silently, no popup
      setLocationState(LOCATIONS[savedId]);
    } else {
      // restaurant_address missing — first time or cleared, show popup
      setShowPopup(true);
      localStorage.setItem(
        "restaurant_address_new",
        LOCATIONS.kvilletorget.address + ", " + LOCATIONS.kvilletorget.city,
      );
      localStorage.setItem(
        "restaurant_phonenumber",
        LOCATIONS.kvilletorget.phonenumber,
      );
      localStorage.setItem("restaurant_id", LOCATIONS.kvilletorget.id);
    }
  }, []);

  const setLocation = (id) => {
    if (LOCATIONS[id]) {
      const loc = LOCATIONS[id];
      setLocationState(loc);

      // Save full address string under the key your app reads
      const fullAddress = `${loc.address}, ${loc.city}`;
      localStorage.setItem("restaurant_address_new", fullAddress);
      localStorage.setItem("restaurant_phonenumber", loc.phonenumber);
      localStorage.setItem("restaurant_id", loc.id);
      // Save id so we can restore the location object on next load
      localStorage.setItem("barleys_location_id", id);

      setShowPopup(false);
    }
  };

  return (
    <LocationContext.Provider
      value={{ location, setLocation, showPopup, setShowPopup }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error("useLocation must be used within LocationProvider");
  return ctx;
};
